<template>
  <a
    class="flex"
    href="https://www.bingciyuan.top/app-release/bingciyuan.apk"
    target="_blank"
  >
    <button
      class="flex-1 cursor-pointer btn-neutral flex items-center gap-1 justify-center rounded-lg h-8 whitespace-nowrap px-2"
    >
      <i class="iconify mingcute--android-2-fill"></i>

      <span class="text-xs">{{ $t("Menus.androidDownload") }}</span>
    </button>
  </a>
</template>
